var login = {
  translation: {
    common: {
      accept: 'Accepter',
      alreadyUser: 'Allerede bruger?',
      and: 'og',
      backToLogin: 'Tilbage til login-side',
      continueWith: 'Fortsæt med {{provider}}',
      createAccount: 'Opret en konto',
      createYourAccount: 'Opret din konto',
      emailOrUsername: 'E-mail eller brugernavn',
      login: 'Log ind',
      logInToBoards: 'Log ind',
      newToBoards: 'Ny i RICE-WORK?',
      pageNotFound_title: 'Siden blev ikke fundet',
      password: 'Adgangskode',
      privacyPolicy: 'Privatlivspolitik',
      register: 'Registrer',
      registerWithGoogle: 'Registrer med Google',
      termsOfService: 'Vilkår for brug',
      togglePasswordVisibility: 'Vis/skjul adgangskode',
    },

    action: {
      logIn: 'Log ind',
    },
  },
};

export { login as default };
